import React, { useEffect } from 'react';
import '@resources/assets/styles/loading.scss';
import ContentHeader from '@components/_commons/ContentHeader';
import { Box, Grid2, SelectChangeEvent } from '@mui/material';
import { Outlet, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';


function Demo(props) {

    useEffect(() => {
        console.log('init page!')
    }, [])

    return (
        <Box className='wrapper-content'>
            <Box id="content-header" className='content-header'>
                <ContentHeader />
            </Box>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '20%',
                alignItems: 'center'
            }}>
                <div>
                    <img src={"https://cdn.coursemos.kr/images/working.gif"} alt="Working" />
                </div>

                <Typography id="text-pre-loading" variant="h6" style={{ marginTop: "15px" }}>
                    준비 중입니다...
                </Typography>
            </div>
        </Box>
    );
}

export default Demo;